/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@coze-arch/i18n';
import { Button } from '@coze-arch/coze-design';

import { useDuplicateBotToSpace } from './use-duplicate-bot-to-space';

export interface DuplicateBotToSpaceProps {
  botId: string;
  disabled?: boolean;
}

export const DuplicateBotToSpace: React.FC<DuplicateBotToSpaceProps> = ({
  botId,
  disabled,
}) => {
  const { contextHolder, open, teamSpaces } = useDuplicateBotToSpace(botId);

  return (
    <>
      <Button
        color="secondary"
        disabled={disabled || !teamSpaces.length}
        onClick={open}
      >
        {I18n.t('bot_copy_to_other_space')}
      </Button>
      {contextHolder}
    </>
  );
};
